 document.addEventListener("DOMContentLoaded", () => {
  const imgCarousel = document.querySelector(".carousel.carousel__images");
  if (!imgCarousel) return;

  const imgViewport = imgCarousel.querySelector(".carousel__viewport");
  const imgTrack    = imgCarousel.querySelector(".carousel__track");
  const imgSlides   = Array.from(imgCarousel.querySelectorAll(".carousel__slide"));
  const imgControls = imgCarousel.querySelector(".carousel__controls");
  const imgPrevBtn  = imgControls?.querySelector("#prevBtn")  || imgControls?.querySelector(".carousel__btn.prev");
  const imgNextBtn  = imgControls?.querySelector("#nextBtn")  || imgControls?.querySelector(".carousel__btn.next");

  // Dots (optional)
  const imgDotsWrap = imgCarousel.querySelector(".carousel__images__dots");
  const imgDots     = imgDotsWrap ? Array.from(imgDotsWrap.querySelectorAll(".carousel__images__dot")) : [];

  let imgIndex = 0;
  let imgSlidesPerView = 1;
  let imgStep = 0;

  function getNumber(val) {
    const n = parseFloat(val);
    return Number.isNaN(n) ? 0 : n;
  }

  function measureImages() {
    imgSlidesPerView = window.matchMedia("(max-width: 768px)").matches ? 1 : 3;
    if (!imgSlides.length) return;

    const slideRect = imgSlides[0].getBoundingClientRect();
    const slideWidth = slideRect.width;

    const cs = getComputedStyle(imgTrack);
    const gap = getNumber(cs.gap || cs.columnGap || 0);

    imgStep = slideWidth + gap;

    const maxIndex = Math.max(0, imgSlides.length - imgSlidesPerView);
    if (imgIndex > maxIndex) imgIndex = maxIndex;

    applyImages();
    updateUiImages();
  }

  function applyImages() {
    const x = -(imgIndex * imgStep);
    imgTrack.style.transform = `translateX(${x}px)`;
    imgTrack.style.transition = imgTrack.style.transition || "transform 300ms ease";
    updateCenterClassImages();
  }

  function updateUiImages() {
    const maxIndex = Math.max(0, imgSlides.length - imgSlidesPerView);
    if (imgPrevBtn) imgPrevBtn.disabled = (imgIndex <= 0);
    if (imgNextBtn) imgNextBtn.disabled = (imgIndex >= maxIndex);

    if (imgDots.length) {
      imgDots.forEach((d, i) => d.classList.toggle("is-active", i === imgIndex));
    }
  }

  function updateCenterClassImages() {
    imgSlides.forEach(s => s.classList.remove("is-center"));
    const start = imgIndex;
    const mid = start + Math.floor(imgSlidesPerView / 2);
    if (imgSlides[mid]) imgSlides[mid].classList.add("is-center");
  }

  function goNextImages() {
    const maxIndex = Math.max(0, imgSlides.length - imgSlidesPerView);
    if (imgIndex < maxIndex) {
      imgIndex++;
      applyImages();
      updateUiImages();
    }
  }

  function goPrevImages() {
    if (imgIndex > 0) {
      imgIndex--;
      applyImages();
      updateUiImages();
    }
  }

  // Hook up arrows
  imgNextBtn && imgNextBtn.addEventListener("click", goNextImages);
  imgPrevBtn && imgPrevBtn.addEventListener("click", goPrevImages);

  // Dots click (optional)
  imgDots.forEach((dot, i) => {
    dot.addEventListener("click", () => {
      imgIndex = i;
      applyImages();
      updateUiImages();
    });
  });

  // Resize handling (debounced with rAF)
  let rAF;
  const onResize = () => {
    cancelAnimationFrame(rAF);
    rAF = requestAnimationFrame(measureImages);
  };
  window.addEventListener("resize", onResize);
  window.addEventListener("load", measureImages);

  measureImages();
});
 
